import React from 'react';
import {FieldViewProps} from "../../../render/view";
import FieldDescriptionEditor_Component from "../components/editor";
import MentionsManager from "../../../../gd/manager/mentions-manager";

export default function FieldDescriptionEditor_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    return <FieldDescriptionEditor_Component className            = {Classes('ui5-field-form-editable', props.className)}
                           type                 = "view"
                           editorType           = "default"
                           placeholder          = "Message"
                           rtfState             = {value}
                           companyId            = {gd.companyId}
                           mentions             = {MentionsManager.getMentions({companyId: gd.companyId})}
                           useLocalSettings     = {false}
                           showControls         = {false}
                           showSettingsButton   = {false}
                           stateSaveInterval    = {500}/>
}
